import React from 'react';
export const getStringFromReactNode = (children) => {
    let label = '';
    React.Children.map(children, child => {
        if (typeof child === 'string') {
            label += child;
            return;
        }
        if (React.isValidElement(child) && child.props.children) {
            label += getStringFromReactNode(child.props.children);
            return;
        }
    });
    return label;
};
//# sourceMappingURL=get-string-from-react-node.js.map